// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + ({"586": "recorder","621": "profiler",}[chunkId] || chunkId) + "." + {"118": "227bbb3a","33": "fc43c9f1","429": "f725a4f1","449": "3aef6b02","563": "1601d87f","586": "a8f16312","621": "429344a8","810": "4875a77b","857": "2de31704",}[chunkId] + ".chunk.js"
}